import { createTheme } from '@mantine/core';
import { BREAKPOINTS } from 'shared/config';
import { Accordion } from './accordion';
import { ActionIcon } from './action-icon';
import { Anchor } from './anchor';
import { Avatar } from './avatar';
import { Badge } from './badge';
import { Button } from './button';
import { Carousel } from './carousel';
import { Checkbox } from './checkbox';
import { CloseButton } from './close-button';
import { ComboboxSearch } from './combobox';
import { DateInput } from './date-input';
import { DatePicker } from './date-picker';
import { DatePickerInput } from './date-picker-input';
import { Divider } from './divider';
import { Input } from './input';
import { Menu } from './menu';
import { Modal, ModalOverlay, ModalRoot } from './modal';
import { Notifications } from './notifications';
import { NumberFormatter } from './number-formatter';
import { NumberInput } from './number-input';
import { Overlay } from './overlay';
import { Pagination } from './pagination';
import { PasswordInput } from './password-input';
import { Popover } from './popover';
import { Radio } from './radio';
import { Select } from './select';
import { Switch } from './switch';
import { Table } from './table';
import { Tabs } from './tabs';
import { TagsInput } from './tags-input';
import { TextInput } from './text-input';

export const theme = createTheme({
	white: 'var(--color-white)',
	black: 'var(--color-black)',
	fontFamily: 'var(--font-family)',
	activeClassName: '',
	focusClassName: 'focused',
	cursorType: 'pointer',
	focusRing: 'never',
	fontSmoothing: true,
	respectReducedMotion: true,
	breakpoints: {
		xs: `${BREAKPOINTS.xs + 1}px`,
		sm: `${BREAKPOINTS.sm + 1}px`,
		md: `${BREAKPOINTS.md + 1}px`,
		lg: `${BREAKPOINTS.lg + 1}px`,
		xl: `${BREAKPOINTS.xl + 1}px`,
	},
	radius: {
		none: 'var(--radius-none)',
		xs: 'var(--radius-xs)',
		sm: 'var(--radius-sm)',
		md: 'var(--radius-md)',
		lg: 'var(--radius-lg)',
		xl: 'var(--radius-xl)',
		'2xl': 'var(--radius-2xl)',
		'3xl': 'var(--radius-3xl)',
		full: 'var(--radius-full)',
	},
	fontSizes: {
		xs: 'var(--text-xs)',
		sm: 'var(--text-sm)',
		md: 'var(--text-md)',
		lg: 'var(--text-lg)',
		xl: 'var(--text-xl)',
		'2xl': 'var(--text-2xl)',
		'3xl': 'var(--text-3xl)',
		'4xl': 'var(--text-4xl)',
		'5xl': 'var(--text-5xl)',
		'6xl': 'var(--text-6xl)',
		'7xl': 'var(--text-7xl)',
		'8xl': 'var(--text-8xl)',
		'9xl': 'var(--text-9xl)',
	},
	lineHeights: {
		xs: 'var(--text-xs-line-height)',
		sm: 'var(--text-sm-line-height)',
		md: 'var(--text-md-line-height)',
		lg: 'var(--text-lg-line-height)',
		xl: 'var(--text-xl-line-height)',
		'2xl': 'var(--text-2xl-line-height)',
		'3xl': 'var(--text-3xl-line-height)',
		'4xl': 'var(--text-4xl-line-height)',
		'5xl': 'var(--text-5xl-line-height)',
		'6xl': 'var(--text-6xl-line-height)',
		'7xl': 'var(--text-7xl-line-height)',
		'8xl': 'var(--text-8xl-line-height)',
		'9xl': 'var(--text-9xl-line-height)',
	},
	shadows: {
		'2xs': 'var(--shadow-2xs)',
		xs: 'var(--shadow-xs)',
		sm: 'var(--shadow-sm)',
		md: 'var(--shadow-md)',
		lg: 'var(--shadow-lg)',
		xl: 'var(--shadow-xl)',
		'2xl': 'var(--shadow-2xl)',
	},
	headings: {
		sizes: {
			h1: {
				fontSize: 'var(--text-4xl)',
				lineHeight: 'var(--text-4xl-line-height)',
				fontWeight: 'var(--font-weight-black)',
			},
			h2: {
				fontSize: 'var(--text-3xl)',
				lineHeight: 'var(--text-3xl-line-height)',
				fontWeight: 'var(--font-weight-semibold)',
			},
			h3: {
				fontSize: 'var(--text-2xl)',
				lineHeight: 'var(--text-2xl-line-height)',
				fontWeight: 'var(--font-weight-semibold)',
			},
		},
	},

	variantColorResolver: () => ({
		background: '',
		border: '',
		color: '',
		hover: '',
		hoverColor: '',
	}),
	components: {
		Button,
		ActionIcon,
		CloseButton,
		Input,
		TextInput,
		Checkbox,
		Popover,
		Menu,
		Badge,
		Modal,
		ModalRoot,
		ModalOverlay,
		Notifications,
		Accordion,
		Pagination,
		Table,
		DatePicker,
		DateInput,
		Overlay,
		ComboboxSearch,
		Tabs,
		Select,
		Anchor,
		Carousel,
		NumberInput,
		Avatar,
		Radio,
		Divider,
		DatePickerInput,
		NumberFormatter,
		TagsInput,
		PasswordInput,
		Switch,
	},
});
